import React from 'react';
import SearchForm from '../components/SearchForm';

export default function HeroSection() {
  return (
    <div className="relative bg-[#1e1b4b] text-white overflow-hidden">

      {/* Background blobs */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-[-15%] left-[-8%] w-72 h-72 sm:w-[500px] sm:h-[500px] bg-violet-600 opacity-25 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-5%] w-60 h-60 sm:w-[400px] sm:h-[400px] bg-amber-500 opacity-20 rounded-full blur-[100px]" />
        <div className="absolute top-[50%] left-[50%] w-40 h-40 sm:w-72 sm:h-72 bg-purple-500 opacity-10 rounded-full blur-[80px]" />
        {/* Grid overlay */}
        <div className="absolute inset-0 opacity-[0.03]"
          style={{ backgroundImage: 'linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(to right, #ffffff 1px, transparent 1px)', backgroundSize: '50px 50px' }} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16 lg:pt-20 pb-0">

        {/* Top badge */}
        <div className="flex justify-center mb-6">
          <span className="inline-flex items-center gap-2 bg-amber-400/10 border border-amber-400/30 text-amber-300 text-xs font-bold px-4 py-2 rounded-full tracking-widest uppercase">
            <span className="w-2 h-2 bg-amber-400 rounded-full animate-pulse" />
            India's Fastest Growing Flight Booking Platform
          </span>
        </div>

        {/* Headline */}
        <div className="text-center mb-6 sm:mb-8">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black leading-[1.05] tracking-tight mb-4">
            Fly More.
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 via-yellow-300 to-violet-400">
              Spend Less.
            </span>
          </h1>
          <p className="text-slate-300 text-base sm:text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
            Compare fares across 100+ airlines, unlock exclusive deals, and book your perfect flight in under 60 seconds — no hidden fees, ever.
          </p>
        </div>

        {/* USP pills */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-8 sm:mb-10">
          {['✅ Lowest Fare Guarantee', '⚡ Book in 60 Seconds', '🔒 Secure Payments', '📞 24/7 Support'].map(pill => (
            <span key={pill} className="bg-white/8 border border-white/15 text-white/80 text-xs sm:text-sm px-3 sm:px-4 py-1.5 rounded-full">
              {pill}
            </span>
          ))}
        </div>

        {/* Search form card */}
        <div className="bg-white/6 backdrop-blur-2xl border border-white/10 rounded-2xl sm:rounded-3xl p-4 sm:p-6 md:p-8 shadow-2xl max-w-5xl mx-auto">
          <SearchForm />
        </div>

        {/* Stats strip */}
        <div className="mt-8 sm:mt-10 pb-12 sm:pb-16 grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-8 max-w-2xl sm:max-w-none mx-auto">
          {[
            { value: '₹ 0',   label: 'Booking Fee' },
            { value: '100+',  label: 'Airlines' },
            { value: '500+',  label: 'Routes' },
            { value: '2M+',   label: 'Happy Travelers' },
          ].map(s => (
            <div key={s.label} className="text-center">
              <p className="text-2xl sm:text-3xl font-black text-white">{s.value}</p>
              <p className="text-slate-400 text-xs sm:text-sm mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom wave */}
      <div className="relative h-12 sm:h-16 -mt-1">
        <svg viewBox="0 0 1440 64" preserveAspectRatio="none" className="absolute bottom-0 w-full h-full" fill="white">
          <path d="M0,64 C360,0 1080,64 1440,0 L1440,64 Z" />
        </svg>
      </div>
    </div>
  );
}
